import {
  StackReact,
  StackGraphql,
  StackNode,
  StackExpress,
  StackMongodb,
  StackApollo,
  StackGithubActions,
  StackReactRouter,
  StackRedux,
  StackFirebase,
  StackTypescript,
  StackTailwindcss,
  StackNPM,
  StackNextJS,
  StackChatGPT,
  StackMarkdown,
} from "./stacks";

// Profile Store
import profilestore01 from "../../images/projects/react/profilestore/profilestore01.png";
import profilestore02 from "../../images/projects/react/profilestore/profilestore02.png";
import profilestore03 from "../../images/projects/react/profilestore/profilestore03.png";
import profilestore04 from "../../images/projects/react/profilestore/profilestore04.png";
import profilestore05 from "../../images/projects/react/profilestore/profilestore05.png";
import profilestore06 from "../../images/projects/react/profilestore/profilestore06.png";
import profilestore07 from "../../images/projects/react/profilestore/profilestore07.png";
import profilestore08 from "../../images/projects/react/profilestore/profilestore08.png";

// To View List
import toviewlist01 from "../../images/projects/react/toviewlist/toviewlist01.png";
import toviewlist02 from "../../images/projects/react/toviewlist/toviewlist02.png";
import toviewlist03 from "../../images/projects/react/toviewlist/toviewlist03.png";
import toviewlist04 from "../../images/projects/react/toviewlist/toviewlist04.png";

// Newspaper
import reddister01 from "../../images/projects/react/reddister/reddister01.png";
import reddister02 from "../../images/projects/react/reddister/reddister02.png";
import reddister03 from "../../images/projects/react/reddister/reddister03.png";
import reddister04 from "../../images/projects/react/reddister/reddister04.png";
import reddister05 from "../../images/projects/react/reddister/reddister05.png";
import reddister06 from "../../images/projects/react/reddister/reddister06.png";
import reddister07 from "../../images/projects/react/reddister/reddister07.png";

// Stack Superflow
import stacksuperflow01 from "../../images/projects/react/stacksuperflow/stacksuperflow01.png";

// Bakery
import bakery01 from "../../images/projects/react/bakery/bakery01.png";

// Component Library
import reactlibrary01 from "../../images/projects/react/reactlibrary/reactlibrary1.png";
import reactlibrary02 from "../../images/projects/react/reactlibrary/reactlibrary2.png";
import reactlibrary03 from "../../images/projects/react/reactlibrary/reactlibrary3.png";
import reactlibrary04 from "../../images/projects/react/reactlibrary/reactlibrary4.png";
import reactlibrary05 from "../../images/projects/react/reactlibrary/reactlibrary5.png";

// Hooks Reference
import hooksreference01 from "../../images/projects/react/hooksreference/hooks1.png";
import hooksreference04 from "../../images/projects/react/hooksreference/hooks4.png";
import hooksreference03 from "../../images/projects/react/hooksreference/hooks3.png";

// Aprenda Agora
import aprendaagora01 from "../../images/projects/react/aprendaagora/aprendaagora01.png";
import aprendaagora02 from "../../images/projects/react/aprendaagora/aprendaagora02.png";
import aprendaagora03 from "../../images/projects/react/aprendaagora/aprendaagora03.png";

export const AprendaAgoraClient: IProject = {
  title: {
    english: "Client App for Language Learning Educational Platform",
    portuguese:
      "Aplicativo Cliente para Plataforma Educativa de Ensino de Idiomas",
  },
  slug: {
    english: "language-learning-platform-client",
    portuguese: "cliente-plataforma-aprendizado-idiomas",
  },
  description: {
    english: "An admin dashboard and landing page for a bakery.",
    portuguese: "Um sistema de gerenciamento e landing page para padaria.",
  },
  features: {
    english: [],
    portuguese: [],
  },
  realClient: true,
  stack: [
    StackNode,
    StackReact,
    StackNextJS,
    StackTypescript,
    StackTailwindcss,
    StackChatGPT,
    StackMarkdown,
  ],
  coverImage: aprendaagora01,
  coverImage2: aprendaagora02,
  images: [aprendaagora01, aprendaagora02, aprendaagora03],
  projectLink: "https://aprendaagora.org/",
};

export const Bakery: IProject = {
  title: {
    english: "Bakery Admin Website & Landing Page",
    portuguese: "Site Admin & Landing Page de Padaria",
  },
  slug: {
    english: "bakery",
    portuguese: "padaria",
  },
  description: {
    english: "An admin dashboard and landing page for a bakery.",
    portuguese: "Um sistema de gerenciamento e landing page para padaria.",
  },
  features: {
    english: [
      "Authentication (login/register with email-password)",
      "Add/update/delete entries",
      "Add title, link, description, tags & type of link",
      "Bookmark important stuff (by 'starring' it)",
      "Mark the already read/watched items as 'viewed'",
      "Search entries by title, description or tags",
      "Filter entries by type (article, video or other), or by starred or viewed",
      "Click on tags to show all entries containing the tag you clicked on.",
      "Sort entries by oldest first, newest first, A-Z (alphabetical) or Z-A (reverse alpha.)",
      "Toast notifications for actions such as adding new entry, or 'starring' it etc.",
      "Dark mode toggle w/ local storage save",
      "Responsive UI for all screens",
    ],
    portuguese: [],
  },
  realClient: true,
  stack: [
    StackReact,
    StackTypescript,
    StackReactRouter,
    StackFirebase,
    StackTailwindcss,
  ],
  coverImage: bakery01,
  coverImage2: bakery01,
  images: [bakery01],
  projectLink: "https://padaria-35820.web.app/",
};

export const ReactLibrary: IProject = {
  title: {
    english: "Simple React Component Library",
    portuguese: "Biblioteca de Componentes React Simples",
  },
  slug: {
    english: "react-component-library",
    portuguese: "biblioteca-componentes-react",
  },
  description: {
    english: "This is a component library for React.",
    portuguese: "Isto é uma biblioteca de componentes para React.",
  },
  features: {
    english: ["Atomic design.", "TailwindCSS support."],
    portuguese: ["Design atômico.", "Suporte TailwindCSS."],
  },
  realClient: false,
  stack: [StackReact, StackTypescript, StackTailwindcss, StackNPM],
  coverImage: reactlibrary01,
  coverImage2: reactlibrary02,
  images: [
    reactlibrary01,
    reactlibrary02,
    reactlibrary03,
    reactlibrary04,
    reactlibrary05,
  ],
  projectLink: "https://simple-react-component-library.web.app/",
  githubLink: "https://github.com/aprendaagora/simple-react-component-library",
};

export const HooksReference: IProject = {
  title: {
    english: "React Hooks Reference",
    portuguese: "Referência dos React Hooks",
  },
  slug: {
    english: "react-hooks-reference",
    portuguese: "referencia-react-hooks",
  },
  description: {
    english:
      "This is a reference guide to React Hooks. A place where you can find example usage of many different React Hooks",
    portuguese:
      "Isto é guia de referência aos React Hooks. Um lugar onde você pode encontrar exemplos de uso dos diferentes React Hooks.",
  },
  features: {
    english: [
      "Vanilla JavaScript and TypeScript support.",
      "Examples with code snippets.",
    ],
    portuguese: [
      "Suporte para Vanilla JavaScript e TypeScript.",
      "Exemplos com trechos de códigos.",
    ],
  },
  realClient: false,
  stack: [StackReact, StackTypescript, StackTailwindcss, StackNPM],
  coverImage: hooksreference01,
  coverImage2: hooksreference03,
  images: [hooksreference01, hooksreference03, hooksreference04],
  projectLink: "https://react-hooks-reference.web.app/",
  githubLink: "https://github.com/ramonfrombr/react-hooks-reference",
};

export const ProfileStore: IProject = {
  title: {
    english: "Profile Store",
    portuguese: "Armazém de Perfis",
  },
  slug: {
    english: "profile-store",
    portuguese: "armazem-de-perfis",
  },
  description: {
    english:
      "Store profile links of people you admire, at one place. Built using MERN stack.",
    portuguese:
      "Armazene links de perfil de pessoas que você admira em um só lugar. Construído usando a pilha MERN.",
  },
  realClient: false,
  features: {
    english: [
      "Authentication (login/register with email-password)",
      "Upload images for display pictures of contacts",
      "Add/update/delete contacts & change display picture",
      "Add/update/delete profile links of individual contacts",
      "Search contacts by name or profile links",
      "Toast notifications for actions - adding/updating/deleting contact, or welcome message etc.",
      "Dark mode toggle w/ local storage save",
      "Responsive UI for all screens",
    ],
    portuguese: [],
  },
  stack: [StackReact, StackReactRouter, StackNode, StackExpress, StackMongodb],
  coverImage: profilestore01,
  coverImage2: profilestore03,
  images: [
    profilestore01,
    profilestore02,
    profilestore03,
    profilestore04,
    profilestore05,
    profilestore06,
    profilestore07,
    profilestore08,
  ],
  projectLink: "https://profile-store-4e872.web.app/login",
  githubLink: "https://github.com/ramonfrombr/mern-profile-store",
};

export const ToViewList: IProject = {
  title: {
    english: "To View List",
    portuguese: "Lista de Visualização",
  },
  slug: {
    english: "to-view-list",
    portuguese: "lista-de-visualizacao",
  },
  description: {
    english:
      "A MERN stack app to keep track of online stuff, which you may want to view later.",
    portuguese:
      "Um aplicativo MERN stack para acompanhar coisas online, que você pode querer visualizar mais tarde.",
  },
  features: {
    english: [
      "Authentication (login/register with email-password)",
      "Add/update/delete entries",
      "Add title, link, description, tags & type of link",
      "Bookmark important stuff (by 'starring' it)",
      "Mark the already read/watched items as 'viewed'",
      "Search entries by title, description or tags",
      "Filter entries by type (article, video or other), or by starred or viewed",
      "Click on tags to show all entries containing the tag you clicked on.",
      "Sort entries by oldest first, newest first, A-Z (alphabetical) or Z-A (reverse alpha.)",
      "Toast notifications for actions such as adding new entry, or 'starring' it etc.",
      "Dark mode toggle w/ local storage save",
      "Responsive UI for all screens",
    ],
    portuguese: [],
  },
  realClient: false,
  stack: [StackReact, StackReactRouter, StackNode, StackExpress, StackMongodb],
  coverImage: toviewlist01,
  coverImage2: toviewlist02,
  images: [toviewlist01, toviewlist02, toviewlist03, toviewlist04],
  projectLink: "https://to-view-list.web.app/",
  githubLink: "https://github.com/ramonfrombr/mern-to-view-list",
};

export const Reddister: IProject = {
  title: {
    english: "Reddister - A Reddit clone",
    portuguese: "Reddister - Um clone do Reddit",
  },
  slug: {
    english: "reddister-reddit-clone",
    portuguese: "reddister-reddit-clone",
  },
  description: {
    english:
      "A feature rich Reddit clone built with MERN stack, that supports image upload, CRUD operations, authentication, and more",
    portuguese:
      "Um clone do Reddit rico em recursos, construído com a pilha MERN, que suporta upload de imagens, operações CRUD, autenticação e muito mais.",
  },
  realClient: false,
  features: {
    english: [
      "React + MaterialUI Frontend",
      "NodeJS + Express + MongoDB backend hosted on render.com",
      "Secure authentication with JWT + Bcrypt",
      "Image upload and storing with Cloudinary",
      "CRUD for posts and comments",
      "Full database search feature",
    ],
    portuguese: [],
  },
  stack: [
    StackGithubActions,
    StackReact,
    StackRedux,
    StackReactRouter,
    StackNode,
    StackExpress,
    StackMongodb,
  ],
  coverImage: reddister01,
  coverImage2: reddister02,
  images: [
    reddister01,
    reddister02,
    reddister03,
    reddister04,
    reddister05,
    reddister06,
    reddister07,
  ],
  projectLink: "https://reddister.web.app/",
  githubLink: "https://github.com/ramonfrombr/mern-reddit-clone",
};

export const StackSuperflow: IProject = {
  title: {
    english: "Stack Superflow - A Stack Overflow clone",
    portuguese: "Stack Superflow - Um clone do Stack Overflow",
  },
  slug: {
    english: "stack-superflow",
    portuguese: "stack-superflow",
  },
  description: {
    english:
      "A feature rich Stack Overflow clone built with MERN+GraphQL stack, that supports CRUD operations, authentication, full database search and more",
    portuguese:
      "Um clone do Stack Overflow rico em recursos, construído com a pilha MERN+GraphQL, que suporta operações CRUD, autenticação, busca completa no banco de dados e muito mais.",
  },
  realClient: false,
  features: {
    english: [
      "Authentication (login/register with username-password)",
      "CRUD questions, answers & comments",
      "Upvote/downvote questions & answers",
      "Tags for organising questions",
      "Page views - A view is registered whenever the question page is opened",
      "Pages for added tags, registered users & more",
      "Sorting of questions on basis of hot, votes, views, newest & oldest",
      "Search questions over the server on basis of question title & body",
      'Pagination of posts in the form of "Load More" button',
      "Error management to prevent app crashes",
      "Toast notifications for actions: adding questions, deleting comments etc.",
      "Loading spinners for relevant fetching processes",
      "Formatted dates for adding/updating questions/answers/comments",
      "Dark mode toggle w/ local storage save",
      "Proper responsive UI for all screens",
    ],
    portuguese: [],
  },
  stack: [
    StackReact,
    StackRedux,
    StackReactRouter,
    StackNode,
    StackExpress,
    StackMongodb,
    StackGraphql,
    StackApollo,
  ],
  coverImage: stacksuperflow01,
  coverImage2: stacksuperflow01,
  images: [stacksuperflow01],
  projectLink: "https://stack-superflow.web.app/",
  githubLink: "https://github.com/ramonfrombr/mern-stack-overflow-clone",
};
